//TODO: consider use types from typescript-rest-api or duplicate them.

export let PaymentMethodType;
(function (PaymentMethodType) {
  PaymentMethodType["UNKNWON"] = "unknown";
  PaymentMethodType["CARD"] = "card";
})(PaymentMethodType || (PaymentMethodType = {}));